import { ElementRef, AfterViewInit, Directive } from '@angular/core';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';

@Directive({
    selector: '[cnaf-affiche-article]'
})

export class CnafAfficheArticle implements AfterViewInit {
    constructor(
        private readonly el: ElementRef,
        protected readonly cnafContacterMaCafService: CnafContacterMaCafService
    ) {
    }

    ngAfterViewInit(): void {
        this.linkFunc();
    }

    linkFunc(): void {
        const navTabs = Array.from(this.el.nativeElement.getElementsByClassName('nav-tabs')) as HTMLElement[];
        const links = Array.from(this.el.nativeElement.getElementsByTagName('a')) as HTMLElement[];

        /* Gestion globales ancres */
        this.gestionAncres(links);

        /* Gestion Bootstrap navTabs */

        for (const navTab of navTabs) {
            const navTabCast = navTab;
            const navTabArray = Array.from(navTabCast.children);
            for (const navTabElem of navTabArray) {
                const navTabAncres = Array.from(navTabElem.getElementsByTagName('a')) as HTMLElement[];
                for (const navTabAncre of navTabAncres) {
                    const navTabAncreElem = navTabAncre;
                    const attrHref = navTabAncreElem.getAttribute('href');
                    this.majIdEtHref(attrHref, navTabAncreElem);
                }
            }
        }
    }

    private majIdEtHref(attrHref: string | null, navTabAncreElem: HTMLElement) {
        if (attrHref?.startsWith("#")) {

            const tabPanes = Array.from(this.el.nativeElement.getElementsByClassName('tab-content'));
            for (const tabPane of tabPanes) {
                const tabPaneCast = tabPane as HTMLElement;
                const tabPanesArray = Array.from(tabPaneCast.children) as HTMLElement[];
                for (const tabPaneElem of tabPanesArray) {
                    const tabPaneElement = tabPaneElem;
                    if (tabPaneElement.getAttribute('id') === attrHref.substring(1)) {
                        navTabAncreElem.setAttribute('href', attrHref + this.cnafContacterMaCafService.tabCounterArticleReponses);
                        tabPaneElement.setAttribute('id', attrHref.substring(1) + this.cnafContacterMaCafService.tabCounterArticleReponses);
                        this.cnafContacterMaCafService.tabCounterArticleReponses++;
                        break;
                    }
                }
            }
        }
    }

    private gestionAncres(links: HTMLElement[]) {
        for (const link of links) {
            const linkCast = link?.getAttribute('href') as string;
            if (linkCast !== null && linkCast.length > 0) {
                if (linkCast.substring(0, 1) === '#') {
                    link.setAttribute('target', '_self');
                }
            }
        }
    }
}
